import memoize from 'transmute/memoize';
import * as ReferenceTypes from 'reference-resolvers-lite/constants/ReferenceTypes';
const DEFAULT_SEARCH_LIMIT = 500;
const SEARCH_LIMIT_OVERRIDES = {
  [ReferenceTypes.PIPELINE_STAGE]: 2000,
  [ReferenceTypes.TEAM]: 1000,
  [ReferenceTypes.USER]: 1000,
  // Note that OWNER only supports a maximum search result page size of 500
  [ReferenceTypes.OWNER]: 500
};

// For now, there's no fetch all support so we instead
// rely on the pagination endpoints. These could fail
// because we won't fetch more than 1 page at a time.
// Fetches max of two pages as a hack to fetch all owner external options: https://git.hubteam.com/HubSpot/ProductSupport/issues/73500
export const fetchAllExternalOptions = memoize((ReferenceResolver, referenceType) => {
  const count = SEARCH_LIMIT_OVERRIDES[referenceType] || DEFAULT_SEARCH_LIMIT;
  return ReferenceResolver.api.search({
    offset: 0,
    count
  }).then(results => {
    if (results.hasMore) {
      return ReferenceResolver.api.search({
        offset: results.offset,
        count
      }).then(secondPageResults => {
        return Promise.resolve(Object.assign({}, secondPageResults, {
          references: results.references.concat(secondPageResults.references)
        }));
      });
    }
    return Promise.resolve(results);
  });
});